<template>
  <b-form @submit.prevent="submitForm">
    <b-form-group>
      <template v-slot:label>IP <span class="text-danger">*</span></template>
      <b-form-input type="text" v-model="ipAddress" name="ipAddress" required/>
    </b-form-group>
    <b-form-group :label="$t('note')">
      <b-form-input type="text" v-model="comment" name="comment" maxlength="255"/>
    </b-form-group>

    <div class="text-right pt-3">
      <b-button type="button" variant="secondary" class="mr-3" @click="onClickCancel" :disabled="isSubmitting">{{ $t("cancel") }}</b-button>
      <b-button type="submit" variant="primary" :disabled="isSubmitting" @click="beforeSubmit">{{ $t("save") }}</b-button>
    </div>
  </b-form>
</template>

<style lang="scss" scoped>

</style>

<script lang="ts">
  import {Component, Emit, Prop, Vue} from 'vue-property-decorator';
  import _ from "lodash";
  import BaseComponent from "@/components/BaseComponent";
  import * as ipPolicyService from "@/service/ipPolicyService";

  @Component
  export default class AddIpPolicyModal extends BaseComponent {

    @Prop({ required: true }) modalId: string;

    ipAddress = "";
    comment = "";

    formErrorMsg = "";
    isSubmitting = false;

    // Emit decorators only
    @Emit("submitted") __submitted() {}


    mounted() {

    }

    onClickCancel() {
      this.$bvModal.hide(this.modalId);
    }

    beforeSubmit() {
      const trimFields = ["ipAddress", "comment"];
      for (const field of trimFields) {
        this[field] = this[field].trim();
      }
    }

    async submitForm() {
      this.formErrorMsg = "";

      try {
        this.isSubmitting = true;
        await ipPolicyService.add({
          ipAddress: this.ipAddress.trim(),
          comment: this.comment.trim()
        });

        this.__submitted();
        this.toastSuccessDelay(this.$t("createSuccessful").toString());
        this.$bvModal.hide(this.modalId);

      } catch (e) {
        this.toastError(e);

      } finally {
        this.isSubmitting = false;
      }
    }

  }
</script>
